import { render, staticRenderFns } from "./ClaimQuickApprove.vue?vue&type=template&id=2eebaf00&"
import script from "./ClaimQuickApprove.vue?vue&type=script&lang=js&"
export * from "./ClaimQuickApprove.vue?vue&type=script&lang=js&"
import style0 from "./ClaimQuickApprove.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports